import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "currentColor",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M84 47.719v30.48a12 12 0 0 1-2.926 8.715A12 12 0 0 1 72.84 91H60V67c0-5.524-4.477-10-10-10s-10 4.476-10 10v24H27.16a12 12 0 0 1-8.235-4.086A12 12 0 0 1 16 78.199v-30.48A16 16 0 0 0 22.359 49h4.762a15.98 15.98 0 0 0 10.238-3.68A16 16 0 0 0 47.639 49h4.72a16 16 0 0 0 10.28-3.68A16 16 0 0 0 72.878 49h4.762A16 16 0 0 0 84 47.72zM89.879 30.48v2.281A12 12 0 0 1 84 43.2 12 12 0 0 1 77.64 45H72.88a12.24 12.24 0 0 1-10.238-5.602A12.28 12.28 0 0 1 52.36 45h-4.719a12.28 12.28 0 0 1-10.28-5.602A12.24 12.24 0 0 1 27.121 45h-4.761A12 12 0 0 1 16 43.2a12 12 0 0 1-5.879-10.439V30.48a9.44 9.44 0 0 1 4.278-8 .6.6 0 0 1 0-.242L16.72 16a10.4 10.4 0 0 1 9.883-6.801h46.8-.003a10.4 10.4 0 0 1 9.882 6.8l2.282 6.52h-.004q.03.118 0 .242a9.43 9.43 0 0 1 4.32 7.719z" }, null, -1)
  ])))
}
export default { render: render }